import { inject, Injector } from '@angular/core';
import { signalStore, withMethods, withProps, withState } from '@ngrx/signals';
import { initialProvinciaState } from './provincia.state';
import { getProvincia } from './provincia.utility';
import { GetCittaGQL, GetProvinciaGQL } from '../../_graphql/generated';

export const ProvinciaStore = signalStore(
  { providedIn: 'root' },
  withState(initialProvinciaState),
  withProps(() => ({
    getterProvincia: inject(GetProvinciaGQL),
  })),
  withMethods(({ getterProvincia, ...store }, injector = inject(Injector)) => ({
    init: getProvincia(injector, store, getterProvincia),
  })),
);
